<div class="tenant-picker-list d-flex flex-column gap-2">
  @if (tenants.status() === 'loading' || tenants.status() === 'idle') {
    <div class="d-flex align-items-center gap-2 text-muted px-2 py-2">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span>Loading tenants...</span>
    </div>
  }
  @else if (tenants.status() === 'error') {
    <div class="alert alert-warning py-2 px-3 mb-0">
      Unable to load tenants.
    </div>
  }
  @else if (tenants.value().length === 0) {
    <div class="alert alert-warning py-2 px-3 mb-0">
      No tenants available.
    </div>
  }
  @else {
    <div class="tenant-picker-list__items d-flex flex-column gap-2">
      @for (tenant of tenants.value(); track tenant.tenantId) {
        <tenant-picker-item
          [tenant]="tenant"
          [isCurrentTenant]="isCurrentTenant(tenant)"
          (selected)="selectTenant($event)">
        </tenant-picker-item>
      }
    </div>
  }
</div>
